module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [(_vm.containerDetails.length > 0 && (_vm.designation == 'manager' || _vm.designation == 'surveyer' || _vm.designation == 'Admin')) ? _c('div', {
    staticClass: "box"
  }, [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Survey & Repair Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.designation != 'surveyer') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Gate-In")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.containerDetails,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "gateInId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "containerNo",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewContainerInPage(row1.item.containerGateInId, row1.item.gateInId)
            }
          }
        }, [_vm._v(_vm._s((row1.item.containerNo == '' || row1.item.gateInType == 'Empty_Vehicle') ? " --- " : row1.item.containerNo))])]
      }
    }, {
      key: "loginTime",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row12.item.loginTime)))])]
      }
    }, {
      key: "delaySurveyStatus",
      fn: function(row123) {
        return [(row123.item.delaySurveyStatus == 1) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Not Completed In 24 Hours")]), _vm._v(" "), _c('br')]) : (row123.item.delaySurveyStatus == 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Survey Pending")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Survey Done")])])]
      }
    }, {
      key: "shippingLine",
      fn: function(row2) {
        return [_c('span', [_vm._v("\n                      " + _vm._s(row2.item.shippingLine) + "\n                      "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                      " + _vm._s(row2.shippingApproval == '' || row2.shippingApproval == null ? "Status : N/A" : "Status: " + row2.shippingApproval) + "\n                      "), _c('br')])]
      }
    }, {
      key: "shippingApproval",
      fn: function(row3) {
        return [_c('span', {
          style: (row3.item.repairCompletedNot == null || row3.item.repairCompletedNot == '' ? {
            'color': 'red'
          } : {
            'color': 'green'
          })
        }, [_vm._v(_vm._s(row3.item.shippingApproval != 'Approved' ? " ---" : row3.item.repairCompletedNot == null || row3.item.repairCompletedNot == '' ? "Pending" : 'Repair Done'))])]
      }
    }, {
      key: "containerStatus",
      fn: function(row32) {
        return [_c('span', {
          style: (row32.item.containerStatus == 1 || row32.item.repairCompletedNot == 'Repair_Done' ? {
            'color': 'green'
          } : {
            'color': 'red'
          })
        }, [_vm._v(_vm._s(row32.item.containerStatus == 1 ? "Completed" : row32.item.repairCompletedNot == "Repair_Done" ? "Ready to Gate Out" : "Pending"))])]
      }
    }, {
      key: "repairCompletedNot",
      fn: function(row13) {
        return [(_vm.designation == 'manager') ? _c('div', [(row13.item.repairCompletedNot == 'Repair_Done' && _vm.designation == 'manager' && row13.item.containerStatus == 0) ? _c('div', [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row13.item.containerGateInId,
            "name": "approval",
            "value": row13.item.repairStatusCon == 1 && row13.item.repairCompletedNot == 'Repair_Done' ? true : false
          },
          on: {
            "change": function($event) {
              _vm.disableGateOut(row13.item, _vm.index)
            }
          }
        }, [_vm._v(_vm._s(row13.item.repairStatusCon == 1 && row13.item.repairCompletedNot == 'Repair_Done' ? 'Yes' : 'No'))]), _vm._v(" "), _c('br')], 1) : _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("N/A")])])]) : _c('div', [_c('span', [_vm._v("N/A")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 ",
    attrs: {
      "limit": "5",
      "align": "center",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.designation != 'surveyer') ? _c('div', {
    staticClass: "box"
  }, [_c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Gate-In Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Gate-In")])], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.itemServiceDetails,
      "fields": _vm.fields1,
      "current-page": _vm.currentPage1,
      "per-page": _vm.perPage1,
      "filter": _vm.filter1,
      "sort-by": _vm.sortBy1,
      "sort-desc": _vm.sortDesc1,
      "sort-direction": _vm.sortDirection1
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy1 = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc1 = $event
      },
      "filtered": _vm.onFiltered1
    },
    scopedSlots: _vm._u([{
      key: "gateInId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "gateInSeries",
      fn: function(row10) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewGateInPage(row10.item.gateInId)
            }
          }
        }, [_vm._v(_vm._s(row10.item.gateInSeries))])]
      }
    }, {
      key: "containerNo",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewContainerInPage(row1.item.containerGateInId, row1.item.gateInId)
            }
          }
        }, [_vm._v(_vm._s((row1.item.containerNo == '' || row1.item.gateInType == 'Empty_Vehicle') ? " --- " : row1.item.containerNo))])]
      }
    }, {
      key: "loginTime",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row12.item.loginTime)))])]
      }
    }, {
      key: "delaySurveyStatus",
      fn: function(row123) {
        return [(row123.item.delaySurveyStatus == 1) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Not Completed In 24 Hours")]), _vm._v(" "), _c('br')]) : (row123.item.delaySurveyStatus == 0) ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Survey Pending")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Survey Done")])])]
      }
    }, {
      key: "shippingLine",
      fn: function(row2) {
        return [_c('span', [_vm._v("\n                      " + _vm._s(row2.item.shippingLine) + "\n                      "), _c('br')])]
      }
    }, {
      key: "maintenanceRequest",
      fn: function(row13) {
        return [_c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s((row13.item.maintenanceRequest == null) ? "--" : _vm.item.maintenanceRequest))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 ",
    attrs: {
      "align": "center",
      "total-rows": _vm.totalRows1,
      "per-page": _vm.perPage1
    },
    model: {
      value: (_vm.currentPage1),
      callback: function($$v) {
        _vm.currentPage1 = $$v
      },
      expression: "currentPage1"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5825a020","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/viewGateIn.vue
// module id = 2653
// module chunks = 0